import { BASE_PATH, BASE_PATH_LIGHTMODE } from '../constants';
import { joinExternalUrl, joinPath } from '../utils/url';

export const ROOT_PAGES = {
  //landing page
  LANDING_PAGE: joinPath(BASE_PATH, '/landing-page'),
  // Home page
  HOME: BASE_PATH,
  //Staking
  STAKING: joinPath(BASE_PATH, '/apps', '/staking'),
  //Staking TOKEN
  STAKING_TOKEN: joinExternalUrl(BASE_PATH_LIGHTMODE, '/staking-token'),
  //Staking Portfolio
  STAKING_TOKEN_PORTFOLIO: joinPath(BASE_PATH, '/staking-token/portfolio'),
  //Staking Portfolio Withdraw
  STAKING_TOKEN_WITHDRAW: joinPath(BASE_PATH, '/staking-token/withdraw'),
  //P2P Lending
  P2P_LENDING: joinPath(BASE_PATH, '/p2p-lending'),
  // pto
  PTO: joinPath(BASE_PATH, '/pto'),
  // pto
  PTO_PORTFOLIO: joinPath(BASE_PATH, '/pto/portfolio'),
  // pto stake
  PTO_STAKE_NFT: joinPath(BASE_PATH, '/pto/stake'),
  // pto stake
  PTO_UNSTAKE_NFT: joinPath(BASE_PATH, '/pto/unstake'),
  // marketplace
  MARKETPLACE: joinPath(BASE_PATH, '/marketplace'),
  // history
  HISTORY: joinPath(BASE_PATH, '/history'),
  //affiliates
  AFFILIATES: joinExternalUrl(BASE_PATH_LIGHTMODE, '/affiliate'),
  // airdrop
  AIRDROP: joinPath(BASE_PATH, '/airdrop'),
  //other
  NO_PERMISSION: joinPath(BASE_PATH, '/no-permission'),
  //user
  USER: joinPath(BASE_PATH, '/user'),
  //vesting
  VESTING: joinPath(BASE_PATH, '/vesting'),
  //vesting
  VESTING_HMC: joinPath(BASE_PATH, '/vesting-hmc'),
  //vesting
  VESTING_VENTURE: joinPath(BASE_PATH, '/vesting-venture'),
  //account
  ACCOUNT: joinExternalUrl(BASE_PATH_LIGHTMODE, '/portfolio'),
  //account edit
  ACCOUNT_EDIT: joinPath(BASE_PATH, '/portfolio/edit'),
  //account rank
  ACCOUNT_RANK: joinPath(BASE_PATH, '/portfolio/rank'),
  //account email verify
  ACCOUNT_EMAIL_VERIFY: joinPath(BASE_PATH, '/portfolio/email-verify'),
  //stacking detail
  STAKING_DETAIL: joinPath(BASE_PATH, '/apps', '/staking/details'),
  // p2p detail
  P2P_LENDING_DETAIL: joinPath(BASE_PATH, '/p2p-lending/details'),
  //PTO details
  PAGE_PTO_DETAIL: joinPath(BASE_PATH, '/pto/details'),
  //marketplace Portfolio
  MARKETPLACE_PORTFOLIO: joinPath(BASE_PATH, '/marketplace/portfolio'),
  //document
  DOCUMENT: joinPath(BASE_PATH, '/docs'),
  //RANK
  RANK: joinPath(BASE_PATH, '/rank'),
  //EDIT PROFILE
  ACCOUNT_EDIT_PROFILE: joinPath(BASE_PATH, '/edit-profile'),
  // verify email
  ACCOUNT_VERIFY_EMAIL: joinPath(BASE_PATH, '/verify-email'),
  //marketplace detail
  MARKETPLACE_DETAIL: joinPath(BASE_PATH, '/marketplace/detail'),
};

export const PAGES = {
  ...ROOT_PAGES,
  //Staking Portfolio Unstake
  STAKING_TOKEN_PORTFOLIO_UNSTAKE: joinPath(
    BASE_PATH,
    `${ROOT_PAGES.STAKING_TOKEN_PORTFOLIO}/:id/unstake`
  ),
  //Staking
  STAKING_TOKEN_DETAIL: `${ROOT_PAGES.STAKING_TOKEN}/:id`,
  //P2P Lending
  P2P_LENDING_DETAIL: `${ROOT_PAGES.P2P_LENDING}/:id`,
  // PTO
  PTO_DETAIL: `${ROOT_PAGES.PTO}/:id`,
};
